import { graphql, Environment } from 'react-relay/legacy';
import commitMutation from 'relay-commit-mutation-promise';
import {
    setLangCookieMutation,
    setLangCookieMutationResponse,
    SetLangCookieInput,
} from './__generated__/setLangCookieMutation.graphql';

const mutation = graphql`
    mutation setLangCookieMutation($input: SetLangCookieInput!) {
        setLangCookie(input: $input) {
            clientMutationId
        }
    }
`;

export function setLangCookie(
    environment: Environment,
    input: SetLangCookieInput
): Promise<setLangCookieMutationResponse> {
    return commitMutation<setLangCookieMutation>(environment, {
        mutation,
        variables: { input },
    });
}
